export const clinicianOnboardingKeys = {
  all: ['clinicianOnboarding'] as const,
  currentStep: () => [...clinicianOnboardingKeys.all, 'currentStep'] as const,
};
